// Back link for auth/signup; <header> sibling to <main>. Same px + max-w-4xl shell as compact auth pages for alignment.
// /login and /signup: no mb-4; bg-gray-50 on both. Sticky + border-b only on /signup hub.
import React from "react";
import { Link, useLocation } from "react-router-dom";

import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

const AuthHeader = (props: any) => {
    const { backUrl } = props;
    const location = useLocation();
    const isSignupHub = location.pathname === "/signup";
    const isLogin = location.pathname === "/login";
    const noBottomMargin = isLogin || isSignupHub;

    const shellPad = "px-4 sm:px-6 lg:px-8";
    const barClass = [
        "w-full z-50 py-2",
        noBottomMargin ? "" : "mb-4",
        shellPad,
        isSignupHub ? "sticky top-0 border-b border-gray-100" : "",
        isLogin || isSignupHub ? "bg-gray-50" : "",
    ]
        .filter(Boolean)
        .join(" ");

    const innerClass = [
        "mx-auto w-full max-w-4xl",
        isSignupHub ? "flex items-center justify-between gap-3" : "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <header className={barClass}>
            <div className={innerClass}>
                <Link to={backUrl ? backUrl : "/"} className="inline-flex items-center justify-center p-2 rounded-full hover:bg-gray-100">
                    <span className="sr-only">뒤로가기</span>
                    <svg className="w-8 h-8 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                </Link>
                {isSignupHub ? (
                    <Link
                        to="/login"
                        className="shrink-0 rounded-lg px-3 py-2 text-sm font-semibold text-[#CF3688] transition-colors duration-200 hover:bg-[#CF3688]/10 hover:text-[#A62B6D] sm:text-base"
                    >
                        {getLanguageValue(PAGE_TYPE.COMMON, "login.btnLogin")}
                    </Link>
                ) : null}
            </div>
        </header>
    );
};

export default AuthHeader;
